import ProtectedBack from "components/layouts/ProtectedLayout/ProtecteBack";
import Protected from "components/layouts/ProtectedLayout/ProtectedLayout";
import AnalyticsModule from "components/modules/Analytics/AnalyticsModule";
import AuthLayout from "components/modules/AuthLayout";
import { DatabaseModule } from "components/modules/Database";
import LeadHistoryBulk from "components/modules/Lead/History/HistoryBulk";
import LeadViewModule from "components/modules/Lead/View/LeadViewModule";
import {
  AccessDenied,
  Billing,
  CheckYourEmail,
  Company,
  Error,
  Integrations,
  Main,
  Maintenance,
  MinimunScore,
  MyAccount,
  NeedHelp,
  OnBoard,
  PageIntent,
  Pixel,
  ResetPassword,
  SocialIntent,
  SuccessPage,
  TermsOfService,
  UpdatePassword,
  Webhooks,
  WebsiteVisitors,
} from "pages";
import { ApiKey } from "pages/ApiKey";
import Pricing from "pages/Plan/Pricing";
import { ScoringFilter } from "pages/ScoringFilter";
import Signin from "pages/User/Auth/Signin";
import Signup from "pages/User/Auth/Signup";
import SignupConfirmAccount from "pages/User/Auth/SignupConfirmAccount";
import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import instance from "utils/axios";
declare global {
  interface Window {
    analytics?: any;
  }
}
const localStorageSessionStartTimeKey = "sessionStartTime";
const MyRouter: React.FunctionComponent = () => {
  // const isMobile = window.innerWidth <= 810; // Adjust the breakpoint as needed
  const location = useLocation();

  const handleCheckServer = async () => {
    try {
      await instance.get("health/database");
    } catch (error) {
      window.location.href = "/service-unavailable";
    }
  };

  useEffect(() => {
    handleCheckServer();
  }, [location]);

  return (
    <Routes>
      <Route element={<Protected />}>
        <Route
          path="/"
          element={<Navigate to={"/dashboard/website-visitors"} />}
        />
        <Route path="/lead/:leadId" element={<LeadViewModule />} />
        <Route path="/onboarding" element={<OnBoard />} />
        <Route path="/exports" element={<LeadHistoryBulk />} />
        <Route path="/database" element={<DatabaseModule />} />
        <Route path="/lead-scoring">
          <Route path="minimum-score" element={<MinimunScore />} />
          <Route path="page-intent" element={<PageIntent />} />
          <Route path="filters" element={<ScoringFilter />} />
        </Route>
        <Route path="/settings">
          <Route path="integrations" element={<Integrations />} />
          <Route path="pixel" element={<Pixel />} />
          <Route path="company-team" element={<Company />} />
          <Route path="webhooks" element={<Webhooks />} />
          <Route path="api-key" element={<ApiKey />} />
        </Route>
        <Route path="/dashboard">
          <Route
            path=""
            element={<Navigate to={"/dashboard/website-visitors"} />}
          />
          <Route
            path="website-visitors"
            element={<WebsiteVisitors formEnrichment={false} />}
          />
          <Route
            path="form-enrichment"
            element={<WebsiteVisitors formEnrichment={true} />}
          />
          <Route path="social-intent" element={<SocialIntent />} />
        </Route>
        <Route path="analytics">
          <Route path="" element={<AnalyticsModule />} />
        </Route>
        <Route path="user">
          <Route path="myAccount" element={<MyAccount />} />
          <Route path="billing" element={<Billing />} />
          <Route path="billing/success" element={<SuccessPage />} />
        </Route>
      </Route>
      <Route element={<ProtectedBack />}>
        <Route path="/pricing" element={<Pricing />} />

        <Route element={<AuthLayout />}>
          <Route path="/welcome" element={<Main />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/confirm-account" element={<CheckYourEmail />} />
          <Route
            path="/auth/verifyAccount/:token"
            element={<SignupConfirmAccount />}
          />
          <Route path="/forgot-password" element={<ResetPassword />} />
          <Route path="/need-help" element={<NeedHelp />} />
        </Route>
      </Route>
      <Route path="/reset-password" element={<UpdatePassword />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/service-unavailable" element={<Maintenance />} />
      <Route path="/accessDenied" element={<AccessDenied />} />

      <Route path="*" element={<Error />} />
    </Routes>
  );
};
export default MyRouter;
